import { Component, input, model, ChangeDetectionStrategy } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faMinus, faPlus } from '@fortawesome/pro-regular-svg-icons';

@Component({
  selector: 'andor-stepper',
  standalone: true,
  imports: [FaIconComponent],
  templateUrl: './stepper.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './stepper.scss',
})
export class Stepper {
  steps = input<number[]>([]);
  value = model<number>(0);
  unit = input<string>('');

  protected readonly faMinus = faMinus;
  protected readonly faPlus = faPlus;

  get currentIndex(): number {
    return this.steps().indexOf(this.value());
  }

  get displayValue(): string {
    const val = this.value();
    return this.unit() ? `${val} ${this.unit()}` : `${val}`;
  }

  get canDecrement(): boolean {
    return this.currentIndex > 0;
  }

  get canIncrement(): boolean {
    return this.currentIndex < this.steps().length - 1;
  }

  decrement() {
    if (!this.canDecrement) return;
    this.value.set(this.steps()[this.currentIndex - 1]);
  }

  increment() {
    if (!this.canIncrement) return;
    this.value.set(this.steps()[this.currentIndex + 1]);
  }
}
